import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { translations } from './translations';

const getInitialLanguage = (): 'es' | 'en' => {
  if (typeof window === 'undefined') return 'es';
  try {
    const stored = window.localStorage.getItem('wai.lang');
    if (stored === 'es' || stored === 'en') return stored;
  } catch {
    // ignore storage access errors (private mode, etc.)
  }
  const browser = (window.navigator?.language || 'es').toLowerCase();
  return browser.startsWith('en') ? 'en' : 'es';
};

i18n
  .use(initReactI18next)
  .init({
    resources: translations,
    lng: getInitialLanguage(),
    fallbackLng: 'es',
    supportedLngs: ['es', 'en'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
    returnNull: false,
    returnObjects: true,
  });

if (typeof document !== 'undefined') {
  document.documentElement.setAttribute('lang', i18n.language.startsWith('en') ? 'en' : 'es');
}

i18n.on('languageChanged', (lng) => {
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('lang', lng.startsWith('en') ? 'en' : 'es');
  }
  try {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('wai.lang', lng.startsWith('en') ? 'en' : 'es');
    }
  } catch {
    // ignore
  }
});

export default i18n;
